import Swiper from "swiper";

// const imageSlider = document.querySelector(".thumb-gallery");

// Select all instances of thumb-gallery and gallery-slider
const imageSliders = document.querySelectorAll(".thumb-gallery");
const gallerySliders = document.querySelectorAll(".gallery-slider");

if (imageSliders.length > 0 && gallerySliders.length > 0) {
  imageSliders.forEach((imageSlider, index) => {
    // Create a unique class or data attribute for each swiper
    imageSlider.classList.add(`thumb-gallery-${index}`);
    gallerySliders[index].classList.add(`gallery-slider-${index}`);

    // Initialize swiper for thumb gallery
    const swiperThumb = new Swiper(`.thumb-gallery-${index}`, {
      loop: true,
      spaceBetween: 12,
      slidesPerView: 2,
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
      },
      allowTouchMove: false,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize swiper for gallery slider
    const swiperGallery = new Swiper(`.gallery-slider-${index}`, {
      loop: true,
      spaceBetween: 12,
      navigation: {
        nextEl: `.swiper-button-next`,
        prevEl: `.swiper-button-prev`,
      },
      thumbs: {
        swiper: swiperThumb,
      },
    });
  });
}
